import {
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";

const getLevelName = (level, t) => t(`reports.levels.${level.id}`, level.id);

export default function LevelSelector({
  getIconComponent,
  isRTL,
  onChange,
  reportLevels,
  selectedLevel,
  t,
}) {
  const activeLevel = reportLevels.levels.find((level) => level.id === selectedLevel);

  return (
    <Menu>
      <MenuButton
        w="full"
        variant="outline"
        size="sm"
        textAlign={isRTL ? "right" : "left"}
      >
        <HStack spacing={1} justify={isRTL ? "flex-end" : "flex-start"}>
          {isRTL && <Icon as={FaChevronDown} />}
          <Text noOfLines={1} flex={1}>
            {activeLevel ? getLevelName(activeLevel, t) : t("reports.reportLevel", "مستوى التقرير")}
          </Text>
          {activeLevel && (
            <Icon as={getIconComponent(activeLevel.icon)} color="blue.500" />
          )}
          {!isRTL && <Icon as={FaChevronDown} />}
        </HStack>
      </MenuButton>
      <MenuList>
        {reportLevels.levels.map((level) => (
          <MenuItem
            key={level.id}
            onClick={() => onChange(level.id)}
            textAlign={isRTL ? "right" : "left"}
          >
            <HStack spacing={1} justify={isRTL ? "flex-end" : "flex-start"}>
              <Text>{getLevelName(level, t)}</Text>
              <Icon as={getIconComponent(level.icon)} color="blue.500" />
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
